import { initComponentsNew } from "@api/utils_2020";
import('./pb23-item--product-officina.css');
import('../pb23-modal--product-officina/pb23-modal--product-officina.css');

const pb23ItemProductOfficina = {
    init: function () {
        const portobelloService =  Util.service("WSPortobelloSite", true, {
            exceptionHandler: console.error,
            reflectSuccess: function(pbSiteService) {                    
                return pbSiteService;
            },
            reflectError: function() {
                console.error("Erro de conexão, verifique sua conexão com a internet.");
            },
        });
        //TODO: Função temporária para ativação da modal
        // abrir modal officina
        $('body').off('click','.pb23-item--product-officina .jsModalDetails').on('click','.pb23-item--product-officina .jsModalDetails',function(e)
        {
            e.preventDefault();
            var sku = $(this).data('sku');
            UtilUi.loadTemplate("assets/components-new/pb23-modal--product-officina/pb23-modal--product-officina.tpl", (dataOn, tpl) => {
                portobelloService.getProductByCode(sku, ['code','zoomImage','description','basesMosaico','hasDamSketchup','hasDamRevit','getRevitZipUrl','getSketchupZipUrl'], {success: function(productObj)
                    {
                        let html = tpl.fetch({ compId: 'modalProductOfficina-'+sku, product: productObj });
                        $("body").append(html);
                        console.log("CLICKED: modalProductOfficina");
                        initComponentsNew("pb23-modal--product-officina");
                        $("#modalProductOfficina-"+sku).showModal(); 
                    }} 
                );
                
            });
            return false;
        });
    }
}
// initialize component
window.loadedComponents.push({ component: 'pb23-item--product-officina', init: pb23ItemProductOfficina.init}); 

export default() => {
    pb23ItemProductOfficina.init();
}